import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery } from "@tanstack/react-query";
import { apiRecent } from "@/api/recent.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { ApiRecentPayload } from "@/types/recents/recents.types.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { queryClient } from "@/queryClient";

export const recentKeys = createQueryKeys("recent", {
  all: null,
});

export const useRecentData = (enabled = true) => {
  return useQuery({
    ...recentKeys.all,
    queryFn: async () => {
      const result = await apiRecent.getAll();
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
    staleTime: 60 * 10 * 1000,
    enabled,
  });
};

export const useRecentUpdate = () => {
  const { onError } = useErrorHandle();

  return useMutation({
    mutationFn: async (entities: ApiRecentPayload[]) => {
      const result = await apiRecent.update({ entities });
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recentKeys.all.queryKey });
    },

    onError: (error: Error) => {
      onError(error);
    },
  });
};
